export const viewTicketsByOptions = [
  { label: 'Issues', value: 'issues' },
  { label: 'Findings', value: 'findings' },
];
